(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'emotion', '../../../styles/colors'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('emotion'), require('../../../styles/colors'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.emotion, global.colors);
    global.SplitButtonMenuStyles = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _emotion, _colors) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)([''], ['']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n    padding: 0 !important;\n    min-width: 32px !important;\n    min-height: 100% !important;\n    border-radius: 0px 3px 3px 0px !important;\n\n    &.disarm {\n      margin-left: 1px;\n    }\n  '], ['\n    padding: 0 !important;\n    min-width: 32px !important;\n    min-height: 100% !important;\n    border-radius: 0px 3px 3px 0px !important;\n\n    &.disarm {\n      margin-left: 1px;\n    }\n  ']),
      _templateObject3 = (0, _taggedTemplateLiteralLoose3.default)(['\n    color: ', ';\n    font-size: 17px !important;\n\n    &.disarm {\n      color: ', ';\n    }\n  '], ['\n    color: ', ';\n    font-size: 17px !important;\n\n    &.disarm {\n      color: ', ';\n    }\n  ']);

  var SplitButtonMenuStyles = {
    menuContainer: (0, _emotion.css)(_templateObject),
    menuButton: (0, _emotion.css)(_templateObject2),
    expandIcon: (0, _emotion.css)(_templateObject3, _colors2.default.jungle, _colors2.default.slate)
  };

  exports.default = SplitButtonMenuStyles;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Buttons/SplitButton/SplitButtonMenu.styles.js
// module id = 1946
// module chunks = 1